/**
 * @typedef { import("./fetcher.js").Fetcher } Fetcher
 */

/**
 * Fetcher implemented with the browser's native fetch API.
 *
 * @implements {Fetcher}
 */
export class NativeFetcher {
  /**
   * Fetch a URL.
   *
   * @param {RequestInfo} requestOrUrl The URL to fetch, or a request object for finer-grain control.
   * @param {RequestInit} [options] An optional request init object.
   * @return {Promise<Response>} A promise for the response.
   */
  fetch(requestOrUrl: RequestInfo, options: RequestInit | undefined = undefined) {
    // eslint-disable-next-line no-restricted-syntax
    return fetch(requestOrUrl, options);
  }
}
